<template>
  <div
    class="Emergency"
    @click="useDialogStore().open('confirmEmergency')"
  >
    <div class="EmergencyInner">
      <h3>SOS linka</h3>
      <button>
        <div class="IconEmergencyWrapper">
          <icon-emergency />
        </div>
        Zavolat SOS
      </button>
      <p>Hasiči, policie, sanitka</p>
    </div>
  </div>
</template>

<style scoped>
@reference "assets/css/tailwind.css";

.Emergency {
  width: 30%;
  height: 100vh;
  min-height: 100%;
  min-height: min-content;
  @apply bg-primary-500;
  cursor: pointer;

  display: none;

  @media (width >= theme(--breakpoint-md)) {
    display: block;
  }

  @media (width >= theme(--breakpoint-lg)) {
    width: 426px;
  }

  .EmergencyInner {
    position: fixed;
    @apply bg-primary-500;
    width: 30%;
    height: 100%;
    right: 0;

    @media (width >= theme(--breakpoint-lg)) {
      width: 426px;
    }

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    text-align: center;
  }

  h3 {
    @apply text-white font-semibold;
    margin-bottom: 20px;
  }

  button {
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    @apply bg-danger;
    box-shadow: 0 8px 20px 0 rgb(0 0 0 / 0.15);
    border-radius: 12px;
    @apply text-white;
    width: 155px;
    height: 128px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .IconEmergencyWrapper {
      @apply bg-white;
      @apply text-danger-500;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
    }

    &:hover {
      box-shadow: 0 8px 25px 0 rgb(0 0 0 / 0.25);
    }
  }

  p {
    opacity: 0.6;
    font-size: 16px;
    color: #fff;
  }
}
</style>
